import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const fetchGradeSuggestions = async (plantId, partialGrade, token, authHeaders = {}) => {
  try {
    const headers = {
      'X-Plant-ID': plantId,
      ...authHeaders
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const params = {
      plant_id: plantId,
      partial_grade: partialGrade
    };

    const response = await axios.get(`${API_BASE_URL}/api/v1/grades/suggestions`, {
      headers,
      params
    });

    return response.data.grades || [];
  } catch (error) {
    console.error('Error fetching grade suggestions:', error);
    return [];
  }
};